import { render, staticRenderFns } from "./Seminars.vue?vue&type=template&id=392534d3&scoped=true&"
import script from "./Seminars.vue?vue&type=script&lang=js&"
export * from "./Seminars.vue?vue&type=script&lang=js&"
import style0 from "./Seminars.vue?vue&type=style&index=0&id=392534d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392534d3",
  null
  
)

export default component.exports